"use strict";
import { formatEther } from "@ethersproject/units";
import { isPooledMarket, Markets } from "nft/types";
import { calcAvgGroupPoolPrice, isInSameMarketplaceCollection, isInSameSudoSwapPool } from "nft/utils";
const isTheSame = (item, routeAsset) => {
  if ("id" in routeAsset && routeAsset.id) {
    return routeAsset.id === item.id;
  } else {
    return "address" in routeAsset && routeAsset.address.toLowerCase() === item.address.toLowerCase() && routeAsset.tokenId === item.tokenId;
  }
};
const getPriceDiff = (oldPrice, newPrice) => {
  const hasPriceDiff = oldPrice !== newPrice;
  const hasVisiblePriceDiff = formatEther(oldPrice) !== formatEther(newPrice);
  return { hasPriceDiff, hasVisiblePriceDiff };
};
const isAveragePriceOfPooledAssets = (asset, numberOfAssetsInPool, expectedPrice) => {
  return !getPriceDiff(calcAvgGroupPoolPrice(asset, numberOfAssetsInPool), expectedPrice).hasVisiblePriceDiff;
};
const isAveragedPrice = (item, items, route, txRoute) => {
  if (!(route && "priceInfo" in route.assetOut)) {
    return false;
  }
  return !!item.marketplace && isPooledMarket(item.marketplace) && isAveragePriceOfPooledAssets(
    item,
    items.filter((routeItem) => itemInRouteAndSamePool(item, routeItem, txRoute)).length,
    route.assetOut.priceInfo.basePrice
  );
};
const getRouteForItem = (item, txRoute) => {
  return txRoute && txRoute.find((r) => r.action === "Buy" && isTheSame(item, r.assetOut));
};
const itemHasRoute = (item, txRoute) => {
  return !!getRouteForItem(item, txRoute);
};
const itemInRouteAndSamePool = (item, routeItem, txRoute) => {
  return itemHasRoute(routeItem, txRoute) && (item.marketplace === Markets.Sudoswap ? isInSameSudoSwapPool(item, routeItem) : isInSameMarketplaceCollection(item, routeItem));
};
export const compareAssetsWithTransactionRoute = (items, txRoute) => {
  let hasPriceAdjustment = false;
  const updatedAssets = items.map((item) => {
    const route = getRouteForItem(item, txRoute);
    if (txRoute && !route) {
      return {
        ...item,
        isUnavailable: true
      };
    }
    let newPriceInfo = item.updatedPriceInfo ? item.updatedPriceInfo : item.priceInfo;
    if (route && "priceInfo" in route.assetOut) {
      const { hasPriceDiff, hasVisiblePriceDiff } = getPriceDiff(
        newPriceInfo.basePrice,
        route.assetOut.priceInfo.basePrice
      );
      newPriceInfo = route.assetOut.priceInfo;
      hasPriceAdjustment = hasPriceDiff;
      if (hasVisiblePriceDiff) {
        if (!isAveragedPrice(item, items, route, txRoute)) {
          return {
            ...item,
            updatedPriceInfo: newPriceInfo
          };
        }
      }
    }
    return {
      ...item,
      priceInfo: newPriceInfo,
      updatedPriceInfo: void 0,
      orderSource: route && "orderSource" in route.assetOut ? route.assetOut.orderSource : void 0
    };
  });
  return { hasPriceAdjustment, updatedAssets };
};
